import './index.scss';
import { NavLink } from 'react-router-dom';
import img_components_sitefooter_lanhu_1 from '@/assets/svg/components-sitefooter-lanhu-1.svg';
import img_components_sitefooter_lanhu_2 from '@/assets/svg/components-sitefooter-lanhu-2.svg';
import img_components_sitefooter_lanhu_3 from '@/assets/svg/components-sitefooter-lanhu-3.svg';
import img_components_sitefooter_lanhu_4 from '@/assets/svg/components-sitefooter-lanhu-4.svg';

const SiteFooter = () => {
  return (
    <footer className="site-footer flex-col justify-end">
      <div className="footer-body">
        <div className="footer-col" data-motion="card-soft">
          <div className="footer-follow-title" data-motion="title">
            FOLLOW US
          </div>
          <div className="footer-social-icons">
            <a
              href="https://www.instagram.com/sakurafloors?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr"
              target="_blank"
              data-motion-interactive="press"
            >
              <img
                className="footer-social-icon"
                alt="instagram"
                referrerPolicy="no-referrer"
                src={img_components_sitefooter_lanhu_3}
              />
            </a>
            <a
              href="https://www.facebook.com/sakurafloors?mibextid=ZbWKwL"
              target="_blank"
              data-motion-interactive="press"
            >
              <img
                className="footer-social-icon"
                alt="facebook"
                referrerPolicy="no-referrer"
                src={img_components_sitefooter_lanhu_4}
              />
            </a>
            <img
              className="footer-social-icon"
              alt="tiktok"
              referrerPolicy="no-referrer"
              src={img_components_sitefooter_lanhu_2}
            />
            <img
              className="footer-social-icon"
              alt="X"
              referrerPolicy="no-referrer"
              src={img_components_sitefooter_lanhu_1}
            />
          </div>
        </div>

        <nav
          className="footer-col footer-links"
          aria-label="Footer navigation"
          data-motion="card-soft"
        >
          <NavLink
            className={({ isActive }) => `footer-nav-link${isActive ? ' active' : ''}`}
            to="/"
            data-motion-interactive="press"
          >
            HOME
          </NavLink>
          <NavLink
            className={({ isActive }) => `footer-nav-link${isActive ? ' active' : ''}`}
            to="/contact-us"
            data-motion-interactive="press"
          >
            CONTACT US
          </NavLink>
          <NavLink
            className={({ isActive }) => `footer-nav-link${isActive ? ' active' : ''}`}
            to="/products"
            data-motion-interactive="press"
          >
            PRODUCTS
          </NavLink>
          <NavLink
            className={({ isActive }) => `footer-nav-link${isActive ? ' active' : ''}`}
            to="/resources"
            data-motion-interactive="press"
          >
            RESOURCES
          </NavLink>
          <NavLink
            className={({ isActive }) => `footer-nav-link${isActive ? ' active' : ''}`}
            to="/about-us"
            data-motion-interactive="press"
          >
            ABOUT US
          </NavLink>
        </nav>

        <div className="footer-col" data-motion="card-soft">
          <div className="footer-contact-title" data-motion="title">
            CONTACT US
          </div>
          {/* <div className="footer-contact-line">Tel：4159289381</div> */}
          <div className="footer-contact-line">Email：info&#64;sakurafloors.com</div>
          <div className="footer-contact-line">Address：PO Box 241，Brentwood, CA 94513</div>
        </div>
      </div>

      <div className="footer-bottom flex-row">
        <div className="fix-width relative">
          <div className="footer-watermark">sakura</div>
          <div className="footer-copyright">© 2026 Sakura Floors All Rights Reserved</div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
